import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";

const useCompanyByOrgNumber = (orgNumber, queryConfig = {}) => {
  return useQuery({
    ...queryConfig,
    enabled: queryConfig.enabled ?? !!orgNumber,
    queryKey: ["companyByOrgNumber", orgNumber],
    queryFn: () => {
      return apiClient.get(`companies/${orgNumber}/simple?orgnumber=1`);
    },
  });
};

export { useCompanyByOrgNumber };
